// โลโก้สินค้า/กลุ่มในหน้า Setting — รูปจาก Wazzup บางตัว 404 จึงต้องมีตัวอักษรสำรอง
import { useState } from "react";
import { cn } from "@shared/lib/utils";

export function ProductLogo({
  url,
  letter,
  size,
  fallbackBg,
}: {
  url?: string | null;
  letter: string;
  /** lg = ขนาดใหญ่ในหัวหน้า config · sm = แถวกะทัดรัดในแผงสไลด์ · xs = เรียงหลายตัวในแถวเดียว */
  size?: "lg" | "sm" | "xs";
  /** พื้นสีของตัวอักษรสำรอง (การ์ดกลุ่มที่ไม่มีรูปใช้สีของกลุ่ม) */
  fallbackBg?: string;
}) {
  const [failed, setFailed] = useState(false);
  const showImg = !!url && !failed;
  return (
    <div className={cn("product-logo", size)}>
      {showImg && <img src={url} alt="" loading="lazy" onError={() => setFailed(true)} />}
      <span
        className="logo-fallback"
        style={
          showImg
            ? undefined
            : { display: "grid", ...(fallbackBg ? { background: fallbackBg, color: "#fff" } : {}) }
        }
      >
        {letter}
      </span>
    </div>
  );
}
